import React, { Component } from 'react'
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";


export default class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currSlide: 0
        };
    };


    responsive = {
        0: { items: 1 },
        400: { items: 1 },
        600: { items: 1 },
        700: { items: 1 },
        800: { items: 3 },
        1024: { items: 3 },
        2048: { items: 5 },
    }
    
    stagePadding = {
        paddingLeft: 40,
        paddingRight: 40,
    }

  render() {

    const {
        currSlide
      } = this.state;

    const {children} = this.props;

    return (
      <div className="row slide" ref="slide">
        <i className="fas fa-chevron-left left" onClick={() => this.Carousel.slidePrev()}></i>
        <i className="fas fa-chevron-right right" onClick={() => this.Carousel.slideNext()}></i>
            <AliceCarousel
                fadeOutAnimation={true}
                slideToIndex={currSlide}
                onSlideChanged={(e) => this.setState({ currSlide: e.item })}
                infinite={false}
                onSlideChange={(e) => this.setState({ currSlide: e.item })}
                buttonsEnabled={true}
                mouseDragEnabled={true}
                dotsDisabled={true}
                responsive={this.responsive}
                stagePadding={this.stagePadding}
                buttonsDisabled={true}
                ref={(el) => (this.Carousel = el)}
            >

            {children}
              
            </AliceCarousel>
        </div>
    )
  }
}
